<template>
  <div class="">
    <v-row>
      <v-col cols="6">
        <p class="headline">จัดการภารกิจ</p>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn class="mr-3" color="success" @click="addMission"
          >เพิ่มภารกิจ</v-btn
        >
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="itemsWithIndex"
          hide-default-footer
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
        >
          <template #[`item.IS_OPEN`]="{ item }">
            {{ item.IS_OPEN | timeStatus }}
          </template>
          <template #[`item.actions`]="{ item }">
            <div class="d-flex justify-center">
              <v-btn
                class="mx-1"
                text
                color="default"
                @click="editMission(item)"
              >
                <v-icon> mdi-file-edit </v-icon>
              </v-btn>
              <v-btn
                class="mx-1"
                text
                color="default"
                @click="deleteMission(item)"
              >
                <v-icon> mdi-trash-can-outline </v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="8" md="4">
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="700">
      <v-form ref="form">
        <v-card>
          <v-card-title>เพิ่มภารกิจ</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="3" class="pb-0">
                <v-text-field
                  outlined
                  label="ข้อที่"
                  v-model="INDEX"
                  type="number"
                  :rules="[(v) => !!v || 'กรุณาใส่ข้อภารกิจ']"
                ></v-text-field>
              </v-col>
              <v-col cols="9" class="pb-0">
                <v-select
                  :items="listSeason"
                  v-model="season"
                  item-value="ID"
                  item-text="NAME"
                  outlined
                  label="ซีซั่น"
                  :rules="[(v) => !!v || 'กรุณาเลือกซีซั่น']"
                ></v-select
              ></v-col>
              <v-col cols="12" class="pb-0">
                <v-text-field
                  outlined
                  label="หัวข้อภารกิจ"
                  v-model="NAME"
                  :rules="[(v) => !!v || 'กรุณากรอกภารกิจ']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0">
                <v-checkbox
                  v-model="checkbox"
                  :label="`มีคำตอบอื่นๆ`"
                ></v-checkbox>
              </v-col>

              <v-col cols="12" class="pb-0">
                <v-select
                  :items="IS_OPENLIST"
                  item-text="text"
                  item-value="value"
                  outlined
                  label="ปิด-เปิดภารกิจ"
                  v-model="IS_OPEN"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn color="primary" @click="save" class="mb-3" width="100%"
              >บันทึก</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-row justify="center">
      <v-dialog v-model="dialogEdit" width="550">
        <v-card height="auto">
          <v-card-title class="mb-2"> แก้ไขคำถาม </v-card-title>
          <v-card-text>
            <v-form ref="editForm">
              <v-row>
                <v-col cols="3" class="pb-0">
                  <v-text-field
                    outlined
                    label="ข้อที่"
                    v-model="INDEX"
                    type="number"
                    :rules="[(v) => !!v || 'กรุณาใส่ข้อภารกิจ']"
                  ></v-text-field>
                </v-col>
                <v-col cols="9" class="pb-0">
                  <v-select
                    :items="listSeason"
                    v-model="season"
                    item-value="ID"
                    item-text="NAME"
                    outlined
                    label="ซีซั่น"
                    :rules="[(v) => !!v || 'กรุณาเลือกซีซั่น']"
                  ></v-select
                ></v-col>
                <v-col cols="12" class="pb-0">
                  <v-text-field
                    outlined
                    label="หัวข้อภารกิจ"
                    v-model="NAME"
                    :rules="[(v) => !!v || 'กรุณากรอกภารกิจ']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-checkbox
                    v-model="checkbox"
                    :label="`มีคำตอบอื่นๆ`"
                  ></v-checkbox>
                </v-col>

                <v-col cols="12" class="pb-0">
                  <v-select
                    :items="IS_OPENLIST"
                    item-text="text"
                    item-value="value"
                    outlined
                    label="ปิด-เปิดภารกิจ"
                    v-model="IS_OPEN"
                  ></v-select>
                </v-col>
                <v-col cols="6"> </v-col>
                <v-col cols="6" class="text-right">
                  <v-btn class="mr-3" color="red" @click="editCancel"
                    >ยกเลิก</v-btn
                  >
                  <v-btn color="success" @click="saveEdit()"
                    >บันทึกข้อมูล</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkbox: false,
      dialog: false,
      dialogEdit: false,
      listSeason: [],
      season: null,
      INDEX: null,
      NAME: null,
      ANSWER: null,
      IS_OPEN: null,
      IDC: null,
      ACTIVITY: null,
      // itemsIndex: [
      //   { value: 1 },
      //   { value: 2 },
      //   { value: 3 },
      //   { value: 4 },
      //   { value: 5 },
      //   { value: 6 },
      //   { value: 7 },
      // ],
      IS_OPENLIST: [
        {
          text: "ปิด",
          value: 0,
        },
        {
          text: "เปิด",
          value: 1,
        },
      ],
      //table
      headers: [
        { text: "ลำดับ", value: "index", align: "left" },
        { text: "ข้อ", value: "INDEX", align: "left" },
        { text: "ซีซั่น", value: "SEASON_ID", align: "left" },
        { text: "ชื่อภารกิจ", value: "NAME", align: "left" },
        { text: "สถานะ", value: "IS_OPEN", align: "left" },
        { text: "จัดการ", value: "actions", align: "center" },
      ],
      itemData: [],
      page: 1,
      numpage: 1,
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  filters: {
    timeStatus(value) {
      if (value === 1) {
        return "เปิด";
      } else {
        return "ปิด";
      }
    },
  },
  computed: {
    itemsWithIndex() {
      return this.itemData.map((items, index) => ({
        ...items,
        index: index + 1,
      }));
    },
  },
  created() {},
  async mounted() {
    await this.listAllMission();
    await this.listAllSeason();
  },
  methods: {
    focusIndex() {},
    addMission() {
      this.dialog = true;
    },
    listAllMission() {
      this.$guest_api.get("/getAllMission").then((res) => {
        this.itemData = res.data.data;
      });
    },
    listAllSeason() {
      this.$guest_api.get("/getSeason").then((res) => {
        this.listSeason = res.data.data;
      });
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$swal({
          icon: "warning",
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          text: "โปรดลองใหม่อีกครั้ง",
        });
      } else {
        let IS_OTHER = 0;
        if (this.checkbox === true) {
          IS_OTHER = 1;
        } else {
          IS_OTHER;
        }

        const iIndex = parseInt(this.INDEX);
        this.$token_api
          .post("/insert-mission", {
            INDEX: iIndex,
            SEASON_ID: this.season,
            NAME: this.NAME,
            IS_OPEN: this.IS_OPEN,
            IS_OTHER: IS_OTHER,
          })
          .then((res) => {
            this.$swal({
              position: "center",
              icon: "success",
              title: "บันทึกสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
            });
            this.dialog = false;
            this.$refs.form.reset();
            this.listAllMission();
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    saveEdit() {
      if (!this.$refs.editForm.validate()) {
        this.$swal({
          icon: "warning",
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          text: "โปรดลองใหม่อีกครั้ง",
        });
      } else {
        let IS_OTHER = 0;
        if (this.checkbox === true) {
          IS_OTHER = 1;
        } else {
          IS_OTHER;
        }
        this.$token_api
          .post("/update-mission", {
            ID: this.IDC,
            INDEX: this.INDEX,
            SEASON_ID: this.season,
            NAME: this.NAME,
            IS_OPEN: this.IS_OPEN,
            IS_OTHER: IS_OTHER,
          })
          .then((res) => {
            this.$swal({
              position: "center",
              icon: "success",
              title: "แก้ไขสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
            });
            this.dialogEdit = false;
            this.listAllMission();
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    editCancel() {
      this.dialogEdit = false;
      this.$refs.editForm.reset();
    },
    editMission(item) {
      this.dialogEdit = true;
      this.INDEX = parseInt(item.INDEX);
      this.NAME = item.NAME;
      this.season = item.SEASON_ID;
      this.IS_OPEN = item.IS_OPEN;
      this.IDC = item.ID;
    },
    async deleteMission(item) {
      this.$swal({
        title: "ต้องการลบข้อมูลนี้หรือไม่?",
        text: "เมื่อลบไปแล้วไม่สามารถเรียกข้อมูลเดิมได้อีก",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$token_api
            .delete("/delete-mission", {
              data: {
                ID: item.ID,
              },
            })
            .then((res) => {
              this.$swal({
                position: "center",
                icon: "success",
                title: "ลบข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              });
              this.listAllMission();
            })
            .catch(function (e) {
              console.log(e);
            });
        }
      });
    },
  },
};
</script>

<style>
</style>